import HeaderBar from "../../common/HeaderBar";
import SideBar from "../../common/SideBar";
import "./upload.css";

import UploadBody from "./UploadBody";
const UploadPage = () => {
  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--aira-chat">
        <SideBar />
        <UploadBody />
      </div>
    </main>
  );
};

export default UploadPage;
